import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HeaderState {
  title = signal<string>(''); // e.g., "Create Account"
  wave = signal<{ min: number; max: number }>({ min: 95, max: 180 });
  isNameShow = signal(true);
  isNotificationIcoShow = signal(true);
  isBackIcoShow = signal(true);
  isSideBarIcoShow = signal(true);
}
